import { css } from '@emotion/core';

export const searchBoxMenuItemCSS = css`
    padding: 0.75rem 24px;
`;
